import beatriceLogo from "../../assets/images/beatriceLogo.png";
import useAuthStore from "../../store/authStore";
import { useNavigate } from "react-router-dom";

const AdminHeader = ({ showMenu = true }) => {
  const navigate = useNavigate();
  const displayUserName = useAuthStore((state) => state.displayUserName);
  const userLastLogin = useAuthStore((state) => state.userLastLogin); 

  const formatDateTime = (dateValue) => {
  const date = dateValue ? new Date(dateValue) : new Date();

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12;

  return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
};

  const handleLogout = () => {
    navigate("/");
  };

  return (
    <header className="new-head">
      <nav className="navbar navbar-default">
        <div className="container-fluid">
          <div className="col-sm-12">

            {/* LEFT - LOGO */}
            <div className="col-sm-4">
              <div className="navbar-header">
                <a className="navbar-brand" href="/">
                  <img
                    src={beatriceLogo}
                    className="logo-icon"
                    alt="logo"
                  />
                </a>
              </div>
            </div>

            {/* CENTER - WELCOME SECTION */}
            {showMenu && (
              <>
                <div
                  className="col-sm-7 text-right p-0"
                  style={{ paddingTop: "5px", color: "#fff" }}
                >
                  <div>
                    <span>Welcome back, </span>
                    <span id="setUserName">
                      {displayUserName || ""}
                    </span>
                  </div>

                  <div>
                    <span id="setLastLoginDate">
                      {formatDateTime(userLastLogin)}
                    </span>
                  </div>
                </div>

                {/* RIGHT - LOGOUT */}
                <div className="col-sm-1">
                  <div className="collapse navbar-collapse">
                    <ul className="nav navbar-nav navbar-right">
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={handleLogout}
                      >
                        <a>
                          <i
                            className="signouticon fas fa-sign-out-alt"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </>
            )}

          </div>
        </div>
      </nav>
    </header>
  );
};

export default AdminHeader;